import { Token } from 'boring-vault-ui/types';
import {
  chainIdToVaultNetwork,
  OChainId,
  ONativeToken,
  TChainId,
} from 'modules/api';
import { getEvmConfig } from 'modules/api/web3SDK/evmConfig';

import { BTC_DECIMALS } from 'modules/common/const';

const evmConfig = getEvmConfig('prod');

function getDepositTokens(chainId?: TChainId): Token[] {
  if (chainId === OChainId.sonic) {
    return [
      {
        displayName: ONativeToken.LBTC,
        address: evmConfig[OChainId.sonic]?.LBTC || '',
        decimals: BTC_DECIMALS,
      },
      {
        displayName: ONativeToken.eBTC,
        address: evmConfig[OChainId.sonic]?.eBTC || '',
        decimals: BTC_DECIMALS,
      },
    ];
  }

  return [
    {
      displayName: ONativeToken.LBTC,
      address: evmConfig[OChainId.ethereum]?.LBTC || '',
      decimals: BTC_DECIMALS,
    },
    {
      displayName: ONativeToken.eBTC,
      address: evmConfig[OChainId.ethereum]?.eBTC || '',
      decimals: BTC_DECIMALS,
    },
  ];
}

function getWithdrawTokens(chainId?: TChainId): Token[] {
  return [
    {
      displayName: ONativeToken.LBTC,
      address: evmConfig[chainId as TChainId]?.LBTC || '',
      decimals: BTC_DECIMALS,
    },
  ];
}

export function getVaultProviderOptions(chainId?: TChainId) {
  return {
    chain: chainIdToVaultNetwork(chainId),
    depositTokens: getDepositTokens(chainId),
    withdrawTokens: getWithdrawTokens(chainId),
  };
}
